import axios from 'axios';
import store from '../redux/store/store';
const API_PACKAGE_URL = import.meta.env.VITE_API_URL;

const packageService = {
  addPackage: async (data) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;

      const response = await axios.post(
        `${API_PACKAGE_URL}/UserPackageDetail`,
        data,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {

      console.error("Ürün eklenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },


  fetchPackage: async (packageId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(
        `/PackageDetail?PackageId=${packageId}`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching package details:', error);
      throw error;
    }
  },


  fetchUserPackage: async (packageDetailId,authUserId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(
        `/UserPackageDetail?PackageDetailId=${packageDetailId}&userId=${authUserId}`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching package details:', error);
      throw error;
    }
  },

  userPackageControl: async (authUserId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(
        `/UserPackageDetail?PackageDetailId=0&userId=${authUserId}&loginPackageControl=true`,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching package details:', error);
      throw error;
    }
  },

}
export default packageService;
